import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: theme.spacing(1)
  },
  icon: {
    marginRight: 4,
    width: 13,
    height: 13,
  },
  grow: {
    flexGrow: 1
  }
}));
